import { useCallback, useEffect, useState } from "react";
import { fetchBrands } from "./requests";
import { getBrandsFormatted } from "./formatters";

export const useGetReferralBrands = () => {
  const [brands, setBrands] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getBrands = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetchBrands();
      const formattedResponse = getBrandsFormatted(response);
      setBrands(formattedResponse);
    } catch (error) {
      setBrands([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void getBrands();
  }, [getBrands]);

  return {
    brands,
    isLoading
  };
};
